/**
 * Øktbytte og TanStack Query-cachen (#141).
 *
 * Når en ny person logger inn — eller noen logger ut — må alt som er hentet
 * for forrige medlem ut av cachen. Ellers ser neste person på et delt
 * kjøkkennettbrett forrige persons lommebok, utkast og adminlister til
 * spørringene rekker å hente på nytt.
 */
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { SESSION_KEY } from './useSession';

export type SessionChange = 'logged_in' | 'logged_out';

export function useResetMemberCache(): (change: SessionChange) => void {
  const qc = useQueryClient();
  return useCallback(
    (change: SessionChange) => {
      // Sett økten til null før resten fjernes, så komponenter som leser
      // useSession (FeedbackWidget, adminlenker) skjules med en gang.
      if (change === 'logged_out') qc.setQueryData(SESSION_KEY, null);
      qc.removeQueries({ predicate: (q) => q.queryKey[0] !== SESSION_KEY[0] });
      if (change === 'logged_in') void qc.invalidateQueries({ queryKey: SESSION_KEY });
    },
    [qc],
  );
}
